import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { setDiagramDateRange } from "../../../redux/slice/diagram";
import { useAbortedEffect, useRawTable } from "../../hooks";
import { CommonAPI } from "../../../axios/api";
import moment from "moment";

export default function Module_ElderlyHealth_ElderlyHealthStatisticsReport112({
  moduleTitle = "",
  moduleData = {},
  apiData,
  setReload,
}) {
  const dispatch = useDispatch();
  const redux_diagram = useSelector((state) => state.diagram);
  const { setTbData, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
    subTitleBgColor: "elderlytitle1",
  });

  // useEffect(() => {
  //   if (
  //     redux_diagram.dateRangeSetting.ElderlyHealthStatisticsReport112 ||
  //     redux_diagram.dateRangeSetting.ElderlyHealthStatisticsReport112 === null
  //   )
  //     return;

  //   let thisYear = Number(moment().format("YYYY"));
  //   let filterData = {
  //     ...redux_diagram.dateRangeSetting,
  //     ElderlyHealthStatisticsReport112: [
  //       {
  //         key: "填寫日期",
  //         start: "2023-01-01",
  //         end: "2023-12-31",
  //       },
  //     ],
  //   };
  //   dispatch(setDiagramDateRange(filterData));
  // }, []);

  useAbortedEffect(
    async (signal) => {
      if (!apiData) return;

      let writeDate = {
        start: "2023-01-01",
        end: "2023-12-31",
      };

      let result_dead = await CommonAPI.getRoot({
        options: { signal },
        path: `/getMatsuIsDead?startDate=${writeDate.start}&endDate=${writeDate.end}`,
      });
      result_dead.data = {
        raw: result_dead.data,
        format: result_dead.data.reduce((pre, cur) => {
          let temp = { ...pre };
          if (!temp[cur.RegionName]) temp[cur.RegionName] = {};
          temp[cur.RegionName][cur.VillageName ? cur.VillageName : "其他"] =
            cur.CNT;
          return temp;
        }, {}),
      };

      let result_live = await CommonAPI.getRoot({
        options: { signal },
        path: `/getMatsuLiveLongTerm?endDate=${writeDate.end}`,
      });
      result_live.data = {
        raw: result_live.data,
        format: result_live.data.reduce((pre, cur) => {
          let temp = { ...pre };
          if (!temp[cur.RegionName]) temp[cur.RegionName] = {};
          temp[cur.RegionName][cur.VillageName ? cur.VillageName : "其他"] =
            cur.CNT;
          return temp;
        }, {}),
      };

      let result_household = await CommonAPI.getRoot({
        options: { signal },
        path: `/getHealthCheckHousehold?endDate=${writeDate.end}`,
      });
      if (result_household.Response === 1) {
        result_household.data = result_household.data.map((item) => ({
          ...item,
          RegionName: String(item.ADDRZIP).slice(3, 6),
          VillageName: item.ADDRAREA,
        }));
        let formatData = formatAction({
          writeDate,
          data: apiData.filter((item) => {
            let diffYear = Number(
              moment(new Date("2023-12-31")).diff(item["填寫日期"], "years")
            );
            return item["年齡"] && item["年齡"] - diffYear >= 65;
          }),
          household: result_household.data,
        }).map((item) => ({
          ...item,
          dead:
            result_dead.data.format[item.RegionName]?.[item.VillageName] ??
            (item.dead !== undefined ? 0 : null),
          inAgency:
            result_live.data.format[item.RegionName]?.[item.VillageName] ??
            (item.inAgency !== undefined ? 0 : null),
        }));

        setTbData({
          raw: formatData,
          format: null,
          export: null,
        });
        setReload(false);
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: result_household.message,
            detail: "",
          })
        );
      }
      dispatch(setProgress({ show: false }));
    },
    [apiData]
  );

  const formatAction = ({ writeDate, data, household }) => {
    // 以鄉分組
    let tempData = {};
    data.forEach((item) => {
      item.VillageName =
        item["村里"] === "null" || !item["村里"] ? "其他" : item["村里"];

      if (!tempData[item["鄉鎮"]]) tempData[item["鄉鎮"]] = {};
      if (!tempData[item["鄉鎮"]][item.VillageName])
        tempData[item["鄉鎮"]][item.VillageName] = {
          data: [],
          inVillage: 0,
        };
      tempData[item["鄉鎮"]][item.VillageName].data.push(item);
    });

    household.forEach((item) => {
      item.VillageName =
        item.VillageName === "null" || !item.VillageName
          ? "其他"
          : item.VillageName;

      if (!tempData[item.RegionName]) tempData[item.RegionName] = {};
      if (!tempData[item.RegionName][item.VillageName])
        tempData[item.RegionName][item.VillageName] = {
          data: [],
          inVillage: 0,
        };
      tempData[item.RegionName][item.VillageName].inVillage = item.CNT;
    });

    Object.keys(tempData).forEach((regionKey) => {
      Object.entries(tempData[regionKey]).forEach(
        ([villageKey, villageData]) => {
          // 去年已健康評估
          let controlCount = Object.values(
            villageData.data
              .filter(
                (item) =>
                  new Date(item["填寫日期"]) >= new Date("2022-01-01") &&
                  new Date(item["填寫日期"]) <= new Date("2022-12-31")
              )
              .reduce(
                (pre, cur) => ({
                  ...pre,
                  [cur["個案ID"]]: cur,
                }),
                {}
              )
          ).length;
          // 當年已健康評估
          let controlVisitData = Object.values(
            villageData.data
              .filter(
                (item) =>
                  new Date(item["填寫日期"]) >= new Date(writeDate.start) &&
                  new Date(item["填寫日期"]) <= new Date(writeDate.end)
              )
              .reduce(
                (pre, cur) => ({
                  ...pre,
                  [cur["個案ID"]]: cur,
                }),
                {}
              )
          );

          tempData[regionKey][villageKey] = {
            inVillage: villageData.inVillage, // 65歲以上在籍人數
            controlCount, // 去年已健康評估
            controlVisitCount: controlVisitData.length, // 當年已健康評估
            ...controlVisitData.reduce((pre, cur) => {
              // 入住機構
              pre.inAgency =
                (pre.inAgency ?? 0) + (cur["機構註記欄位"] === "1" ? 1 : 0);
              // 死亡
              pre.dead =
                (pre.dead ?? 0) +
                (cur["死亡註記"] === "1" &&
                new Date(cur["死亡日期"]) >= new Date(writeDate.start) &&
                new Date(cur["死亡日期"]) <= new Date(writeDate.end)
                  ? 1
                  : 0);
              // 健康
              pre.level1 =
                (pre.level1 ?? 0) +
                (["健康訪視", "衰弱前期訪視"].includes(cur["列管級數"])
                  ? 1
                  : 0);
              // 衰弱
              pre.level2 =
                (pre.level2 ?? 0) +
                (["衰弱訪視"].includes(cur["列管級數"]) ? 1 : 0);
              // 失能
              pre.level3 =
                (pre.level3 ?? 0) +
                (["失能非長照訪視", "失能長照訪視"].includes(cur["列管級數"])
                  ? 1
                  : 0);

              return pre;
            }, {}),
          };
        }
      );
    });

    let formatData = Object.entries(tempData).reduce(
      (preMain, [RegionKey]) => [
        ...preMain,
        ...Object.entries(tempData[RegionKey]).map(
          ([VillageKey, VillageData], index) => ({
            RegionName: RegionKey,
            VillageName: VillageKey,
            rowSpan_RegionName:
              index === 0 ? Object.keys(tempData[RegionKey]).length : null,
            ...VillageData,
          })
        ),
      ],
      []
    );

    return formatData;
  };

  return (
    <>
      <div className="w-full overflow-auto">
        <div>
          {renderTable({
            moduleTitle: moduleData.label,
          })}
        </div>
      </div>
    </>
  );
}
